import React from 'react';
/* eslint react/prop-types: 0 */
import css from './ProfileAddress.module.css';

const Nav = props => {
  const dots = [];
  for (let i = 1; i <= props.totalSteps; i += 1) {
    const isActive = props.currentStep === i;
    dots.push(
      <span
        key={`step-${i}`}
        className={`${css.dot} ${isActive ? css.active : ''}`}  >
        &bull;
      </span>
    );
  }

  return <div className={css.nav}>{dots}</div>;
};

export default Nav;
